import { createFileRoute } from '@tanstack/react-router'
import CalculateStudentScore from '@/components/adminPage/student/CalculateStudentScore'

export const Route = createFileRoute('/admin/database/student-grades')({
  component: CalculateStudentScore,
})
